import React from 'react'
import { StepType } from '../Stepper'

/** Render a top label for step */
export const StepperLabelHorizontal: React.FC<StepperLabelType> = (props: StepperLabelType) => (
    <div className="step-label step-label-horizontal">
        {
            props.steps.map((step, index) => (
                <div 
                    className={`step-label-item ${index === props.stepIndex && 'active'} ${index === props.stepIndex && 'active-index'}`} 
                    key={index}
                    onClick={() => props.onClick?.(step, index)}>
                    <h1><span className="badge">{index + 1}</span> {step.title}</h1>
                    { step.subTitle && <h3>{step.subTitle}</h3> }
                    <span className="step-arrow"></span>
                </div>
            ))
        }
    </div>
)

export type StepperLabelType = { 
    /** Array of step */
    steps: Array<StepType>
    /** Currently step actived */
    stepIndex: number,
    /** Callback on item click */
    onClick?: (step: StepType, index: number) => void,
}